import { useCookies } from 'react-cookie'

import { CardType } from 'types/deck'
import { PRICE_NAMES } from 'types/active'

import { useGetDeckTotals } from '../../DeckHeader/useGetHeaderInfo'

import CustomIcon, { PRICE_SOURCE_TO_ICON } from 'components/elements/CustomIcon'

import { getPriceStringFromFloat } from 'utils/Price'

import styles from './priceTable.module.scss'

type Props = {
  cards: CardType[]
  priceSource: number
}

const PriceTable = ({ cards, priceSource }: Props) => {
  const priceSourceOneTotals = useGetDeckTotals(cards, priceSource)

  const estCost = getPriceStringFromFloat(priceSourceOneTotals.estDeckCost, priceSource)
  const minPrice = getPriceStringFromFloat(priceSourceOneTotals.minimumDeckCost, priceSource)
  const excludingBasics = getPriceStringFromFloat(priceSourceOneTotals.costWithoutBasics, priceSource)
  const excludingOwned = getPriceStringFromFloat(priceSourceOneTotals.excludingExactOwned, priceSource)
  const excludingAny = getPriceStringFromFloat(priceSourceOneTotals.excludingAnyOwned, priceSource)

  const [{ tbId: userId }] = useCookies(['tbId'])

  return (
    <div className={styles.container}>
      <h4>
        <CustomIcon name={PRICE_SOURCE_TO_ICON[priceSource]} />
        {PRICE_NAMES[priceSource]} - {estCost}
      </h4>

      <div className={styles.table}>
        <div className={styles.header}>
          <span>Cheapest edition</span>
          <span>Excluding basics</span>
          <span>Excluding Collection (Owned)</span>
          <span>Excluding Collection (Any)</span>
          <span>% of cards w/ price</span>
        </div>

        <div className={styles.row}>
          <span>{minPrice}</span>
          <span>{excludingBasics}</span>
          <span>{!!userId ? excludingOwned : 'N/A'}</span>
          <span>{!!userId ? excludingAny : 'N/A'}</span>
          <span>{priceSourceOneTotals.cardsMatchedPercent}%</span>
        </div>
      </div>
    </div>
  )
}

export default PriceTable
